/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { hostingMap } from "constants/admin";
import { useI18n } from "hooks/i18n/i18n";
import React, { useEffect } from "react";
import { useSelector } from "store";
import { CarrierPaymentCompleted } from "ui/Streaming/LiveCommerce/CarrierPaymentCompleted";
import { CarrierPaymentProcedureRequired } from "ui/Streaming/LiveCommerce/CarrierPaymentProcedureRequired";
import { NormalButton } from "ui/Streaming/LiveCommerce/NormalButton";
import { scrollTop } from "utility/index";
import { getBelongedHosting } from "utility/storage";

import type { Store } from "store";

type CompletePurchaseProps = {
  clearLiveCommerceCart: () => void;
};
export const CompletePurchaseV2: React.FC<CompletePurchaseProps> = (props) => {
  const isDarkModeEnabled = useSelector(
    (state: Store) => state.streaming.streamingSettings.isDarkModeEnabled
  );
  const phonePurchaseUrl = useSelector(
    (state: Store) => state.streaming.liveCommerce.phonePurchaseUrl
  );
  const classes = completePurchaseStyles();
  const [domain] = hostingMap[getBelongedHosting()];
  const { t } = useI18n();

  const didMount = () => {
    scrollTop();
  };
  useEffect(didMount, []);

  return (
    <div css={classes.root}>
      {phonePurchaseUrl ? (
        <CarrierPaymentProcedureRequired
          isDarkModeEnabled={isDarkModeEnabled}
        />
      ) : (
        <CarrierPaymentCompleted isDarkModeEnabled={isDarkModeEnabled} />
      )}

      <div css={classes.buttonList}>
        {phonePurchaseUrl ? (
          <NormalButton
            isDarkModeEnabled={isDarkModeEnabled}
            type={"primary"}
            label={t("streaming.commerceModal.transitionButton")}
            onClick={() => {
              window.open(
                phonePurchaseUrl,
                "決済ページ",
                "width=500,height=500"
              );
            }}
          />
        ) : (
          <React.Fragment>
            {domain && (
              <a
                href={`https://${domain}/account/ticket`}
                target={"_blank"}
                rel={"noopener noreferrer"}
              >
                <NormalButton
                  isDarkModeEnabled={isDarkModeEnabled}
                  type={"primary"}
                  label={t("streaming.commerceModal.checkMyTickets")}
                />
              </a>
            )}
          </React.Fragment>
        )}

        <NormalButton
          isDarkModeEnabled={isDarkModeEnabled}
          type={"secondary"}
          label={t("streaming.commerceModal.closeButton")}
          onClick={props.clearLiveCommerceCart}
        />
      </div>
    </div>
  );
};

const completePurchaseStyles = () => {
  const root = css`
    height: 400px;
    overflow-y: auto;
  `;
  const buttonList = css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 216px;
    margin: 20px auto 0;
  `;
  return {
    root,
    buttonList,
  };
};
